import React from 'react';
import { useTheme } from '../ThemeContext';
import Footer from './Footer';
import { POLICY_EFFECTIVE_DATE, POLICY_LAST_UPDATED } from '../utils/legal';

export const SUBPROCESSORS = [
  { name: 'Supabase', role: 'database, authentication, storage; AWS us-east-1' },
  { name: 'Netlify', role: 'hosting and serverless functions' },
  { name: 'Stripe', role: 'payments' },
  { name: 'Resend', role: 'email delivery' },
  { name: 'Anthropic', role: 'AI Assistant' },
  { name: 'Microsoft 365', role: 'business email for support, legal, and privacy requests' },
];

export const SUBPROCESSOR_CHANGE_NOTICE =
  "We'll post changes here at least 14 days before a new subprocessor starts processing customer data.";

const Subprocessors = ({ onBack }) => {
  const { colors } = useTheme();

  return (
    <div className="app-scroll" style={{ ...styles.container, background: colors.background, color: colors.text }}>
      <div style={styles.content}>
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            style={{ ...styles.backButton, color: '#59c4c4', borderColor: '#59c4c4' }}
          >
            ← Back
          </button>
        )}

        <h1 style={{ ...styles.title, color: colors.text }}>Subprocessors</h1>
        <p style={{ ...styles.meta, color: colors.textSecondary }}>
          Effective {POLICY_EFFECTIVE_DATE}
        </p>
        <p style={{ ...styles.meta, color: colors.textSecondary }}>
          Last Updated {POLICY_LAST_UPDATED}
        </p>
        <p style={{ ...styles.text, color: colors.text }}>
          Pacarion uses the following subprocessors to operate the service:
        </p>
        <ul style={{ ...styles.list, color: colors.text }}>
          {SUBPROCESSORS.map((item) => (
            <li key={item.name}>
              <strong>{item.name}</strong>
              {' — '}
              {item.role}
            </li>
          ))}
        </ul>
        <p style={{ ...styles.text, color: colors.text }}>{SUBPROCESSOR_CHANGE_NOTICE}</p>
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem 1rem 0',
    boxSizing: 'border-box',
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%',
    flex: '1 0 auto',
  },
  backButton: {
    background: 'transparent',
    border: '2px solid',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginBottom: '2rem',
  },
  title: {
    fontSize: '2.5rem',
    marginBottom: '0.5rem',
  },
  meta: {
    fontSize: '0.9rem',
    marginBottom: '2rem',
  },
  text: {
    lineHeight: '1.8',
    marginBottom: '1rem',
  },
  list: {
    lineHeight: '1.8',
    marginLeft: '2rem',
    marginBottom: '1rem',
  },
};

export default Subprocessors;
